var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatingStarEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.3472 28.2641L53.0556 25.3057L43.9861 6.91685C42.3611 3.63908 37.6528 3.59741 36.0139 6.91685L26.9445 25.3057L6.65279 28.2641C3.0139 28.7919 1.55557 33.278 4.19446 35.8474L18.875 50.153L15.4028 70.3613C14.7778 74.0141 18.625 76.7502 21.8472 75.0419L40 65.5002L58.1528 75.0419C61.375 76.7363 65.2222 74.0141 64.5972 70.3613L61.125 50.153L75.8056 35.8474C78.4445 33.278 76.9861 28.7919 73.3472 28.2641ZM53.9722 47.8196L57.2639 67.0419L40 57.9724L22.7361 67.0419L26.0278 47.8196L12.0556 34.2085L31.3611 31.403L40 13.903L48.6389 31.403L67.9445 34.2085L53.9722 47.8196Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingStarEmpty);
export default __webpack_public_path__ + "static/media/rating-star-empty.0b923493209059d000b5d130a47f179d.svg";
export { ForwardRef as ReactComponent };